import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'

// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsapHorizontalLoop } from "./gsapHorizontalLoop";
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';

// Swiper
import Swiper from 'swiper';
import { Autoplay, EffectFade, Pagination, Navigation } from 'swiper/modules';

import Cookies from 'js-cookie';

// Components

// Global
window.Alpine = Alpine;

// GSAP Configuration
gsap.registerPlugin(ScrollTrigger, Draggable, InertiaPlugin);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.gsapHorizontalLoop = gsapHorizontalLoop;
window.Draggable = Draggable;
window.InertiaPlugin = InertiaPlugin;

// Swiper
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

window.Swiper = Swiper;
Swiper.use([Autoplay, EffectFade, Pagination, Navigation]);

// Cookies
window.Cookies = Cookies;

// Inits
Alpine.plugin(collapse);
Alpine.start();